import service from '@/utils/server';

const modName='/bd/purchArrivalPlan/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const importData = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  return service({
    ...config,
    url: modName + 'importData',
    method: 'post',
    data
  });
};

//修改重量
export const updateWeight = data => {
  return service({
    url: modName + 'updateWeight',
    method: 'post',
    data
  });
};

export const downtemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/purchArrivalPlan/api/index.js